export interface SuggestionItem {
  id: string
  display?: string
  avatar?: string
}

export type TriggerType = 'user' | 'emoji'

export interface TriggerConfig {
  char: string
  type: TriggerType
}

export interface TriggerState {
  type: TriggerType
  query: string
  triggerIndex: number
}

export const TRIGGERS: TriggerConfig[] = [
  { char: '@', type: 'user' },
  { char: ':', type: 'emoji' },
]
